import * as z from "zod/v4";
import { literal } from "zod/v4";
import { ConfirmCompareProductsSchema } from "../../agents/support-agents/confirm-compare-products";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";

export const ProductComparisonMessageSchema =
  BaseActionableComponentMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_COMPARISON),
    structuredContent: ConfirmCompareProductsSchema,
  });

export const ProductComparisonMessageDbParser =
  ProductComparisonMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductComparisonMessage = z.infer<
  typeof ProductComparisonMessageDbParser
>;
